import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RouterModule } from '@angular/router';

import { InputFormFieldComponent } from './input-form-field/input-form-field.component';
import { InputFormSelectComponent } from './input-form-select/input-form-select.component';
import { InputFileComponent } from './input-file/input-file.component';
import { InputDateRamgePickerComponent } from './input-date-ramge-picker/input-date-ramge-picker.component';
import { InputDatepickerComponent } from './input-date-picker/input-date-picker.component';
import { StepComponent } from './step/step.component';
import { RightPageContentComponent } from './right-page-content/right-page-content.component';
import { NavegationComponent } from './navegation/navegation.component';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { FooterComponent } from './footer/footer.component';
import { RoblexPipesModule } from '../pipes/roblex-pipes.module';
import { HeaderComponent } from './header/header.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { RoblexDirectivesModule } from '../directives/roblex-directives.module';
import { TradingCalculatorComponent } from './trading-calculator/trading-calculator.component';
// import { RoblexModalModule } from './modal/modal.module';
import { CameraComponent } from './camera/camera.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { RoblexCollapsedSidepanelModule } from './collapsed-sidepanel/collapsed-sidepanel.module';
import { RoblexCollapsedSidepanelService } from './collapsed-sidepanel/collapsed-sidepanel.service';
import { HeaderCollapsedSidepanelComponent } from './header-collapsed-sidepanel/header-collapsed-sidepanel.component';
import { LetterAvatarComponent } from './letter-avatar/letter-avatar.component';
import { MY_FORMATS } from '../constants/my-format.constant';
import { CalculatorComponent } from './calculator/calculator.component';
import { CalculatorInputComponent } from './calculator-input/calculator-input.component';
import { ScheduleNotificationsComponent } from './schedule-notifications/schedule-notifications.component';
import { RoblexModalModule } from './modal';
import { RatingComponent } from './rating/rating.component';
import { ProgressComponent } from './progress/progress.component';
import { ChangeInputComponent } from './change-input/change-input.component';

// // Depending on whether rollup is used, moment needs to be imported differently.
// // Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// // syntax. However, rollup creates a synthetic default module and we thus need to import it using
// // the `default as` syntax.
// import * as moment from 'moment';

// const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/

const components = [
    InputFormFieldComponent,
    InputFormSelectComponent,
    InputFileComponent,
    InputDateRamgePickerComponent,
    InputDatepickerComponent,
    StepComponent,
    RightPageContentComponent,
    NavegationComponent,
    AlertMessageComponent,
    FooterComponent,
    HeaderComponent,
    DropdownComponent,
    TradingCalculatorComponent,
    CameraComponent,
    SnackBarComponent,
    HeaderCollapsedSidepanelComponent,
    LetterAvatarComponent,
    CalculatorComponent,
    CalculatorInputComponent,
    ScheduleNotificationsComponent,
    RatingComponent,
    ProgressComponent,
    ChangeInputComponent,
];

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        RoblexPipesModule,
        RoblexDirectivesModule,
        // Modals
        RoblexModalModule,
        RoblexCollapsedSidepanelModule,
        // MATERIAL
        ClipboardModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatSnackBarModule,
    ],
    exports: [...components],
    providers: [
        RoblexCollapsedSidepanelService,
        [
            // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
            // application's root module. We provide it at the component level here, due to limitations of
            // our example generation script.
            { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
            { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
            },
        ],
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RoblexComponentsModule {}
